import React from 'react'

export default function PageNotFound (): React.ReactElement {
  return (
    <div>PageNotFound</div>
  )
}
